module.exports = __webpack_public_path__ + "static/media/993946.9c9b2d65.png";